import React, { useState } from 'react'
import styles from './CSS/Input.module.css'

function Input(props) {
  // "props" is short for "Properties"
  // in this component, the only props we have is the name of the parent function that we can call
  
  // header information for the api
  // api key is stored in a hidden local file called .env, and the variable name is:
  // REACT_APP_API_KEY_TOKEN
  const options = {
    method: 'GET',
    headers: {
      accept: 'application/json',
      Authorization: `Bearer ${process.env.REACT_APP_API_KEY_TOKEN}`
    }
  };
  

  // variables to store the names of actors from input field
  const [firstActor, setFirstActor] = useState(""); 
  const [secondActor, setSecondActor] = useState("");

  

  // stores the value of the first input field into the firstActor variable
  const handleFirstInput = (event) => {
    setFirstActor(event.target.value);
  }

  // stores the value of the second input field into the secondActor variable
  const handleSecondInput = (event) => {
    setSecondActor(event.target.value);
  }

 

  
  // API call to get the actor info when you give it the actor name
  const getActorID = async(actorName) => {
    try {
        const response = await fetch(`https://api.themoviedb.org/3/search/person?query=${actorName}&include_adult=false&language=en-US&page=1`, options);
        const data = await response.json();
      
        for (let i in data.results){
          if (data.results[i].known_for_department === "Acting"){
            return data.results[i];
          }
        }
       
        return data.results[0];

    } catch (error) {
      console.error(error);
    }
  }

 // API call to get the actor's movies/shows when you give it the actor id
  const getActorMovies = async(actorID, actor) => {
    try {
      const response = await fetch(`https://api.themoviedb.org/3/person/${actorID}/combined_credits?language=en-US`, options);
      const data = await response.json();
      for (let i = 0; i < data.cast.length; i++){
        data.cast[i].actorName = actor;
        if (data.cast[i].media_type ==="tv"){
          data.cast[i].original_title = data.cast[i].original_name;
        }
      }
      // console.log(data.cast)
      return data.cast;
    } catch (error){
      console.log(error);
    }  
  }

  
  const filterMovies = (movie1, movie2) => {
    // iterate over the arrays, and find matches


    // 1ST CASE
    // 2 nested for loops
    // for each object in movie1
      // iterate over each object in movie2
        // if object in movie1 == object in movie2, add to results (meaning the movie/show is the same)

    // problem ==> O(mn)


    // 2ND CASE
    // alternative -> hashmap 
    // how do we set this up?
    // 2 separate for loops to fill up 2 separate hashmaps --> 1 map per array
    // for each object in movie1
    // for each object in movie2
    // O(n)

    // filter how?
    // hashmaps ==> key : value
    // key --> id
    // value --> object containing all the data of the movie with that id
    const firstMap = new Map();
    const secondMap = new Map();
    // fill up the firstMap map
    for (let i = 0; i < movie1.length; i++){
      // "set" function -> (key, value)
        firstMap.set(movie1[i].id, movie1[i])
    }

    for (let i = 0; i < movie2.length; i++){
      secondMap.set(movie2[i].id, movie2[i])
    }

    // if you know the key, you can just ask the map if the key exists without searching the whole map
    
    let small;
    let big;

    if (firstMap.size < secondMap.size){
      small = firstMap;
      big = secondMap;
    } else {
      small = secondMap;
      big = firstMap;
    }


    let results = [];
    // iterate over everything in the small map, and see if it's in the big map too
    // 10763 -- "News"
    // 10764 -- "Reality"
    // 10767 -- "Talk"
    // 10751 -- I have no idea but it works :D
    // 99 -- "Documentary"


    // each Movie object in the movie1 and movie2 lists have 
    for (let [key, value] of small){
        if(big.has(key) 
            && !value.genre_ids.includes(10763) 
            && !value.genre_ids.includes(10764) 
            && !value.genre_ids.includes(10767) 
            && !value.genre_ids.includes(10751) 
            && !value.genre_ids.includes(99)) {
              value.secondActorName = big.get(key).actorName;
              value.secondCharacterName = big.get(key).character;
            results.push(value);
        }
    }


    results = results.filter(function( element ) {
      return element !== undefined;
   });
  //  
    // if list1 < list2
    // for (var i = 0; i < list1.length; i++)

    //  ! if true, !true === 0. 
    
    // O(1)

    // !true --> false (0) ==> "opposite"
    // number !== 1 ==> "not"
    if (results.length === 0){
      return -1;
    }

    return results;
  }

  // function that gets called when we click our "search" button
  // calls api functions and gets actor ids and actor movies/shows
  // AFTER we implement filtering of results, we send the filtered results up to 
  // App.js, but right now it just sends up dummy data
  const handleButtonClick = async() => {
    // resetting errors
    document.getElementById("first_actor_input").style.border = "3px solid transparent";
    document.getElementById("second_actor_input").style.border = "3px solid transparent";
    document.getElementById("second_error_message").style.visibility = "hidden";
    document.getElementById("first_error_message").style.visibility = "hidden";
    

    // check if the actor names are the same. If so, show error message
    if (firstActor === secondActor) {
      showError('first', 1);
      showError('second', 1);
    
    } else {
      if (firstActor && secondActor){
        // assigns the actor ids and names after getting them from the api
        let firstID = await getActorID(firstActor);
        let secondID = await getActorID(secondActor);
        // both IDs are valid
        if (firstID && secondID){
          // assigns the movies for each acter after getting them in the other api call
    
          const firstMovies = await getActorMovies(firstID.id, firstID.name);
          const secondMovies = await getActorMovies(secondID.id, secondID.name);
      
          // filter movies by calling our Filter results component
          const filteredMovies = filterMovies(firstMovies, secondMovies);
      
          // sends information up to parent function, which will be the "addToResults" function in App.js
          props.parentFunction(filteredMovies);
        } else if(firstID && !secondID){ // first actor ID is valid, second isn't
          showError('second',2);
        } else if (secondID && !firstID){
          showError('first',2);
        
        } else {
          showError('first',2);
          showError('second',2);
        }
      } else if(firstActor && !secondActor){
        showError('second', 1);
        // document.getElementById("second_actor_input").style.border = "3px solid red";
      } else if (secondActor && !firstActor){
        showError('first', 1);
        // document.getElementById("first_actor_input").style.border = "3px solid red";
      } else {
        showError('first',1);
        showError('second',1);
        // document.getElementById("first_actor_input").style.border = "3px solid red";
        // document.getElementById("second_actor_input").style.border = "3px solid red";
      }
    }
   
  }

  // handle event where user clicks the return key
  const clickReturn = (event) => {
    if (event.key === 'Enter') {
      handleButtonClick();
    }
  }



  // changes the CSS of input bars depending on error
  // "number" is the input bar number
  // "bar" is the number of attributes that will show (i.e. just the border, or message and border)
  const showError = (number, bar) => {
    if (bar === 2){
      document.getElementById(number+"_error_message").style.visibility = "visible";
    }
    document.getElementById(number+"_actor_input").style.border = "3px solid red";
  }
  
  

  return (
    <div>
        <div className={styles.input_grid_container}>
          <div className={styles.col}>
              <input type='text' placeholder='First Actor' onChange={handleFirstInput} id="first_actor_input" onKeyDown={clickReturn}></input>
              <p className={styles.error_message} id={"first_error_message"}>Bad Actor Name</p>
            </div>
            <div className={styles.col}>
              <input type='text' placeholder='Second Actor' onChange={handleSecondInput} 
              id="second_actor_input" onKeyDown={clickReturn}></input>
              <p className={styles.error_message} id={"second_error_message"}>Bad Actor Name</p>
             </div>
        </div>
        <button className={styles.submit_button} onClick={handleButtonClick}>Search</button>

    </div>
  )
}


export default Input
